import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["content"],
  _excluded2 = ["children"];
import { H7 } from 'foundations-components/transitional/components/H7';
import { Popover, PopoverHeader, PopoverFooter, PopoverBody } from 'foundations-components/transitional/components/Popover';
import { SideNav } from 'foundations-components/transitional/components/SideNav';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CardMenu = _ref => {
  let {
      content
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    body,
    header,
    footer
  } = content;
  return /*#__PURE__*/_jsx(Popover, Object.assign({
    inlineSize: "300px"
  }, props, {
    content: /*#__PURE__*/_jsxs("div", {
      children: [header && /*#__PURE__*/_jsx(PopoverHeader, {
        paddingBlockEnd: "0",
        paddingBlockStart: "300",
        paddingInline: "300",
        children: header
      }), body && /*#__PURE__*/_jsx(PopoverBody, {
        padding: "0",
        children: body
      }), footer && /*#__PURE__*/_jsx(PopoverFooter, {
        padding: "0",
        children: footer
      })]
    })
  }));
};
export const CardMenuHeader = ({
  children
}) => /*#__PURE__*/_jsx(H7, {
  children: children
});
export const CardMenuOptions = _ref2 => {
  let {
      children
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(SideNav, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(View, {
      paddingBlock: "300",
      paddingInlineStart: "300",
      children: children
    })
  }));
};